export default __webpack_public_path__ + "static/media/argon-react.00b5a811.png";